export enum CheckOnInsertType {
  DO_NOT_ENROLL = 'DoNotEnroll',
  SKIP_TASKS = 'SkipTasks',
}
